var InfoLauncher = function() {
    this.launch = function() {
        window.open(CudaLaunch.serverConfiguration.infoFileName, "_blank");
    };
};

module.exports = InfoLauncher;

